import { useAProgress } from 'hooks/useAProgress'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { SharedModalContent } from 'views/components/SharedModal'

type Props = {
  onClose: () => void
  id: number
  onSuccess: () => void
}

export const RemoveRailsRates: FC<Props> = ({ onClose, id, onSuccess }) => {
  const { t } = useTranslation(['rates'])

  const [progress, remove] = useAProgress(() => apiClient.delete(endpoints.LogisticsKR.railwaysRates(id)), {
    eventName: 'removeRailsRates',
    onSuccess,
  })

  return (
    <ResponsiveModal
      id="removeRailsRates"
      onClose={onClose}
      title={t('removeRate')}
      onConfirm={remove}
      confirmButtonText={t('common:yes_remove')}
      progress={progress}
      size="small"
    >
      <SharedModalContent></SharedModalContent>
    </ResponsiveModal>
  )
}
